import { gql } from '@apollo/client'

import { SHOP_CUSTOMER_SPREEDLY_CARD_FRAGMENT } from '../../fragments/shop/customerSpreedlyCard'
import { SHOP_SQUARE_CUSTOMER_CARD_FRAGMENT } from '../../fragments/shop/squareCustomerCard'

export const GET_CURRENT_CUSTOMER_PAYMENT_CARDS = gql`
  query CurrentCustomerPaymentCards {
    currentCustomer {
      id
      spreedlyCards {
        ...CustomerSpreedlyCard
      }
      squareCards {
        ...ShopSquareCustomerCard
      }
    }
  }
  ${SHOP_CUSTOMER_SPREEDLY_CARD_FRAGMENT}
  ${SHOP_SQUARE_CUSTOMER_CARD_FRAGMENT}
`
